import { Injectable, inject } from '@angular/core';
import { UIBModalServiceOptions } from '@b2b/types/core';

import { UIB_MODAL_PORT } from './uib-modal.port';

/**
 * ModalService — Angular 18.
 *
 * Ported 1:1 from apps/b2b-ui/common/services/modal/modal.service.ts
 * (legacy AngularJS name 'ModalService'). Thin wrapper over AngularJS
 * `$uibModal` (ui.bootstrap), reached through UIB_MODAL_PORT.
 *
 * Registered back into AngularJS under 'ModalService' via downgradeInjectable
 * in app/upgrade/ng-downgraded-components.ts. Wave 3 item #27.
 *
 * `confirm()` opens the legacy `ConfirmCustomModalController` template; that
 * controller/template still live in AngularJS, so the legacy module shell
 * keeps declaring 'ui.bootstrap' and 'acme.view.application.modals.confirmCustom.controllers'
 * for module-graph parity.
 */
@Injectable({ providedIn: 'root' })
export class ModalService {
  private $uibModal = inject(UIB_MODAL_PORT);

  open<T>(options: UIBModalServiceOptions) {
    return this.$uibModal.open<T>(options);
  }

  confirm(props: { title: string; message: string; okText?: string; hideOkText?: boolean; cancelText?: string }) {
    return this.$uibModal
      .open({
        templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
        size: 'md',
        controller: 'ConfirmCustomModalController',
        resolve: {
          modalTitle: () => props.title,
          modalMessage: () => props.message,
          okText: () => props.okText ?? 'Done',
          cancelText: () => props.cancelText ?? 'Cancel',
          hideOkText: () => !!props.hideOkText,
        },
      })
      .result.then(() => true)
      .catch(() => false);
  }
}
